export default class SurveysFinalize {

  constructor() {}

  render() {

    $('.remove-access').click(function() {
      $(this).closest('.editor').remove();
    })

  }

}